/**
 * MIRA DatePicker Component
 * Wraps Shadcn DatePicker with MIRA design system styles
 */

import React from 'react';
import { DatePicker as ShadcnDatePicker } from '@/components/ui/date-picker';
import { cn } from '@/lib/utils';
import styles from '@/styles/components/date-picker.module.css';

export const DatePicker = ({ className, ...props }) => {
  return (
    <ShadcnDatePicker
      className={cn(styles.miraDatePicker, className)}
      {...props}
    />
  );
};

DatePicker.displayName = 'MiraDatePicker';
